import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {searchStaffRoleDiscountRateLimits} from "./actions";
import ListView from "../common/ListView";
import {roundAmount} from "../utils/money";
import {Link} from "react-router-dom";

class StaffRoleDiscountRateLimitsPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    /* state */
    search: PropTypes.object.isRequired,
    /* actions */
    searchStaffRoleDiscountRateLimits: PropTypes.func.isRequired,
  };

  render() {
    const {
      searchStaffRoleDiscountRateLimits,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Staff Role',
        dataIndex: 'staffRoleName',
        key: 'staffRoleName',
        sorter: true
      },
      {
        title: 'Discount Limit',
        dataIndex: 'discountRateLimit',
        key: 'discountRateLimit',
        render: (limit) => `${roundAmount(limit * 100, 0)} %`,
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, staffRoleDiscountRateLimit) => {
          return <Link to={`/discount-rate-limit/update/${encodeURIComponent(staffRoleDiscountRateLimit.staffRoleId)}`}>Edit</Link>;
        }
      }
    ];
    return (<ListView
      title="Discount Limits"
      loading={searching}
      columns={columns}
      dataSourceProvider={searchStaffRoleDiscountRateLimits}
      dataSource={results}
      pagination={pagination}
      searchFilter={searchFilter}
      filters={filters}
      sorter={sorter}
      rowKey="staffRoleId"
    />);
  }
}

const mapStateToProps = state => ({
  loading: state.staffRoleDiscountRateLimit.staffRoleDiscountRateLimitsLoading,
  search: state.staffRoleDiscountRateLimit.search,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchStaffRoleDiscountRateLimits,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(StaffRoleDiscountRateLimitsPage);



// WEBPACK FOOTER //
// ./src/StaffRoleDiscountRateLimit/StaffRoleDiscountRateLimitsPage.js